import Container from '@material-ui/core/Container'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 auto;
  background-color: ${({ theme }) => theme.webMktPalette.background.gray};
  background-image: url('/steam-img/MAC_SHAPES_XS.svg');
  background-repeat: no-repeat;
  padding: 24px 0 60px 0;
  background-position: top right;
  position: relative;

  .PartnersLocator__wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column-reverse;
    }
  }

  .PartnersLocator__itemsContainer {
    width: calc(100% - 324px);

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: 100%;
    }

    /* No search Results */
    .SearchListing__searchNoResults {
      display: none;

      margin: 48px 0;
      visibility: hidden;
      opacity: 0;
      transition: all 0.2s ease;

      h2 {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 800;
        line-height: 36px;
        letter-spacing: 0;
      }

      p {
        padding-top: 8px;
        color: rgb(39, 49, 57);
        font-size: 16px;
        line-height: 24px;
      }
    }

    .SearchListing__searchNoResults--active {
      display: block;
      visibility: visible;
      opacity: 1;
      transition: all 0.2s ease;
    }

    .SearchListing__searchNoResults__list {
      margin-top: 32px;
      padding-left: 32px;
      list-style: disc;
    }

    .SearchListing__searchNoResults__listItem {
      margin-bottom: 24px;
      padding-top: 4px;
      color: rgb(39, 49, 57);

      p {
        &:before {
          left: 7px;
          border-bottom: 2px solid ${({ theme }) => theme.webMktNewPalette.black};
          border-left: 2px solid ${({ theme }) => theme.webMktNewPalette.black};
        }

        &:after {
          border: 2px solid ${({ theme }) => theme.webMktNewPalette.black};
        }
      }
    }
  }

  .PartnersLocator__filter--desktop {
    ${({ theme }) => theme.breakpoints.down('xs')} {
      display: none;
    }

    display: block;
  }

  .PartnersLocator__filter--mobile {
    ${({ theme }) => theme.breakpoints.down('xs')} {
      display: block;
      padding: 0 16px 24px 16px;
      background-color: ${({ theme }) => theme.webMktPalette.background.gray};

      .PartnersLocator__becomePartnerTitle {
        padding-top: 24px;

        color: rgb(39, 49, 57);
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        letter-spacing: 0;
      }

      .PartnersLocator__becomePartnerDesc {
        margin: 16px 0;

        color: rgb(39, 49, 57);
        font-size: 14px;
        line-height: 24px;
      }

      .PartnersLocator__becomePartnerCTA {
        border: none !important;
        border-radius: 1px;
        background: rgb(0, 0, 0);
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 24px;

        img {
          margin-left: 30px;
          vertical-align: middle;
        }
      }

      .PartnersLocator__becomePartnerCTA--link {
        border: none;
        border-radius: 1px;
        color: rgb(0, 103, 223);
        background: none;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;

        img {
          width: 32px;
          margin-left: 12px;
          vertical-align: middle;
        }
      }
    }

    display: none;
  }
`

export const PartnersSearch = styled.div`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: flex;
    flex-wrap: wrap;
    height: unset;
    margin-bottom: 24px;
  }

  margin-bottom: 36px;
  height: 58px;

  .PartnersLocator__typesContainer {
    border: none;
    display: inline-block;

    a {
      display: block;
      line-height: 1.2;
      font-size: 14.5px;
      padding: 4.5px 0;
      color: #0091ae;
      font-weight: 500;
      text-decoration: none;

      &:hover {
        color: #007a8c;
        text-decoration: underline;
      }
    }
  }

  .PartnersLocator__types {
    display: flex;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      overflow-x: scroll;
      flex-wrap: wrap;
    }

    li {
      flex: 0 0 auto;
      margin-right: 8px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        margin-bottom: 12px;
      }

      &.selected {
        a {
          background-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          border: 1px solid ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          color: #ffffff;
          text-decoration: none;
        }
      }

      a {
        border-radius: 24px;
        border: 1px solid rgb(227, 227, 227);
        letter-spacing: 0px;
        line-height: 24px;
        color: #273139;
        font-size: 14px;
        font-weight: normal;
        padding: 12px 16px;
        background-color: #ffffff;

        &:hover,
        &:focus,
        &:active {
          background-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          border: 1px solid ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
  }

  .PartnersLocator__searchContainer {
    ${({ theme }) => theme.breakpoints.down('sm')} {
      flex: 0 0 auto;
      margin-bottom: 24px;
    }
  }

  .PartnersLocator__search {
    float: left;
    padding: 0;
    margin-right: 5px;

    border-radius: 24px;
    border: 1px solid rgb(227, 227, 227);
    letter-spacing: 0px;
    line-height: 24px;
    color: #273139;
    font-size: 14px;
    font-weight: normal;
    background-color: #ffffff;

    input {
      display: inline-block;
      transition: all 0.2s ease-in-out;
      border: none;
      box-shadow: none;
      width: auto;
      margin-bottom: 0;
      padding: 0;
      line-height: 24px;
      color: #273139;
      max-width: 0;
      opacity: 0;
      transition: all 0.2s ease-in-out;

      &.expanded {
        max-width: 200px;
        opacity: 1;
      }

      &:focus {
        border: none;
        box-shadow: none;
      }
    }

    .close {
      display: inline-block;
      transition: all 0.2s ease-in-out;
      padding: 12px 17px;
      cursor: pointer;
      line-height: 24px;
      border-radius: 24px;
    }

    .fa-search {
      display: inline-block;
      transition: all 0.2s ease-in-out;
      padding: 12px 17px;
      cursor: pointer;
      line-height: 24px;
      border-radius: 24px;

      &:before {
        content: '' !important;
        position: relative;
        top: 2px;
        background-image: url('/steam-img/search.svg');
        background-size: cover;
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
        display: inline-block;
        background-position: 100%;
      }

      &:hover,
      &:focus {
        background-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
        color: #ffffff;
        text-decoration: none;
      }

      &:hover {
        &:before {
          background-image: url('/steam-img/Search-white.svg');
        }
      }

      &.active {
        opacity: 0;
        padding-right: 0;
        width: 0;
        cursor: auto;

        &:hover,
        &:focus {
          color: #273139;
          background-color: #ffffff;
        }
      }
    }

    .fa-times {
      &:before {
        content: ' ' !important;
        background-image: url('/steam-img/Close_Weak.svg');
        background-size: contain;
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
        display: inline-block;
        background-position: 0 2px;
      }

      &.close {
        opacity: 0;
        padding-left: 0;
        padding-right: 0;
        width: 0;
        transition: all 0.2s ease-in-out;

        &:before {
          background-image: url('/steam-img/Close.svg');
        }

        &.active {
          opacity: 1;
          width: auto;
          padding-right: 18px;
        }
      }
    }
  }
`

export const Grid = styled.div`
  background-image: url('/steam-img/Grid-Partners.svg');
  width: 100%;
  height: 168px;
  top: 0;
  position: absolute;
`

export const PaginationContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  justify-content: center;
`

export const PartnersHeader = styled.div`
  max-width: 800px;
  margin-bottom: 54px;
  margin-top: 56px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-bottom: 24px;
  }

  h1 {
    margin-bottom: 16px;
    font-size: 56px;
    line-height: 1.2;
    margin-top: 0;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 8px;
    }
  }

  p {
    color: #253139;
  }
`

export const GridWrapper = styled.div`
  background-color: ${({ theme }) => theme.webMktPalette.background.gray};
  color: #444;
  font-size: 0.6em;
  margin-bottom: 24px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 64px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
`

export const GridBox = styled.a`
  background-color: #fff;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-content: center;
  align-content: center;
  position: relative;
  transition: box-shadow 0.3s;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
    margin: 0 0 16px 0;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    text-decoration: none;
    box-shadow: 0 10px 50px -5px rgba(0, 0, 0, 0.15);

    .Partner-Info__Name {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }
  }

  a {
    color: ${({ theme }) => theme.webMktPalette.text.actionBlack};
    font-size: 20px;
    font-weight: 800;
    line-height: 24px;
    text-decoration: none;
  }
`

export const PartnerInfo = styled.div`
  padding: 0 24px 24px 24px;
  p {
    color: #8a97a0;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    margin-top: 8px;
    letter-spacing: normal;
  }
  .Partner-Info__Name {
    color: ${({ theme }) => theme.webMktNewPalette.black};
    font-size: 20px;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: normal;
    transition: 0.1s color ease-in-out;
    margin: 10px 0;
  }

  .description {
    overflow: hidden;
    width: 100%;
    max-height: 235px;
    color: #8a97a0;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    margin: 5px 0;
  }
`

export const HeaderContainer = styled.span`
  margin: 24px 0 0 24px;
`

export const PartnerLogoContainer = styled.div`
  margin: 16px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 152px;
`

export const PartnerLogo = styled.img`
  max-height: 120px;
  max-width: 100%;
  min-height: 0px;
  border: 0;
`

export const FilterContainer = styled.div`
  margin-bottom: 36px;
  margin-left: 24px;
  flex: 1 0 auto;
  -webkit-flex: 1 0 auto;
  width: calc(25% - 24px);
  order: 1;
`

export const HeaderTags = styled.div<{ $level?: string }>`
  padding: 2px 10px;

  background-color: ${({ theme, $level }: any) => {
    switch ($level) {
      case 'Platinum':
      case 'Premier':
        return '#D3E2E9'
      case 'Gold':
        return '#F4B742'
      case 'Diamond':
        return '#4EE2EC'
      case 'Authorized':
        return '#ADF1C3'
      case 'Certified':
        return theme.webMktPalette.text.primaryBlack
      case 'Award':
        return '#38C6F4'
      case 'Featured':
        return '#fa4616'
      default:
        return '#fff'
    }
  }};

  border: ${({ $level }: any) => {
    switch ($level) {
      case 'Diamond':
        return '1px solid #4EE2EC'
      case 'Gold':
        return '1px solid #ffb40e'
      case 'Silver':
        return '1px solid #fff'
      case 'Featured':
        return '1px solid #fa4616'
      case 'default':
        return '1px solid #fff'
    }
  }};

  color: ${({ $level, theme }: any) => {
    switch ($level) {
      case 'Platinum':
      case 'Gold':
      case 'Authorized':
        return theme.webMktPalette.text.primaryBlack
      case 'Certified':
      case 'Award':
      case 'Featured':
        return theme.webMktPalette.text.primaryWhite
      default:
        return '#273139'
    }
  }};

  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 16px;
  display: inline-block;
`

export const ItemTags = styled.div`
  margin: 24px 24px 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;

  ${HeaderTags} {
    p {
      color: inherit;
      margin: 0;
    }
  }
`

export const PartnerInfoCountry = styled.span`
  margin-bottom: 8px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  justify-content: space-between;
  justify-content: space-between;
  align-items: center;
  color: #273139;
  font-size: 12px;
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 16px;
`

export const PartnersLocatorFilters = styled.div`
  margin-left: 24px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-left: 0;
  }
  .PartnersLocator__filtersContainer {
    width: 300px;
    flex-shrink: 0;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: 100%;
      margin-bottom: 36px;
    }
  }

  .PartnersLocator__filter {
    position: relative;

    &--desktopBecomeAPartner {
      display: none;
    }
  }

  .PartnersLocator__filterTitle {
    color: rgb(0, 0, 0);
    font-size: 12px;
    line-height: 16px;
  }

  .PartnersLocator__filterOpened {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    display: block;
    width: calc(100% - 2px);
    max-height: 250px;
    overflow-y: auto;
    transition: all 0.5s ease;
    visibility: hidden;
    opacity: 0;
    border-top: 0;
    border: 1px solid #6a6a6a;
    border-radius: 0px;

    &.is-active {
      border-top: 0;
      transition: all 0.5s ease;
      visibility: visible;
      opacity: 1;
    }

    ul {
      background-color: #fff;

      li {
        padding: 16px 8px 16px 16px;
        color: rgb(89, 90, 92);
        font-size: 16px;
        line-height: 24px;
        text-transform: capitalize;

        &:hover {
          cursor: pointer;
          background-color: ${({ theme }) => theme.webMktPalette.background.gray};
        }
      }
    }
  }

  /* Scrollbar styling */
  .PartnersLocator__filterOpened::-webkit-scrollbar-track {
    /*   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
    border-radius: 0;
    background-color: #fff;
  }

  .PartnersLocator__filterOpened::-webkit-scrollbar {
    width: 6px;
    background-color: #6a6a6a;
  }

  .PartnersLocator__filterOpened::-webkit-scrollbar-thumb {
    border-radius: 0;
    -webkit-box-shadow: inset 0 0 6px ${({ theme }) => theme.webMktNewPalette.alphaBlack[30]};
    background-color: #555;
  }
  /* End Scrollbar styling */

  .PartnersLocator__filterClosed {
    position: relative;
    display: block;
    margin-top: 8px;
    margin-bottom: 24px;
    padding-top: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
    padding-right: 50px;
    border: 1px solid rgb(106, 106, 106);
    border-radius: 0px;
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    cursor: pointer;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.is-active {
      background-color: ${({ theme }) => theme.webMktPalette.background.gray};

      &:after {
        transition: rotate 0.2s ease, bottom 0.2s ease;
        transform: translateY(-50%) rotate(-180deg);
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 24px;
      transition: rotate 0.2s ease, bottom 0.2s ease;
      transform: translateY(-50%);
      background: url('/steam-img/arrows/Arrow_Down_24.svg') no-repeat;
      width: 12px;
      height: 8px;
    }
  }

  /* Reset Filters */
  .partners-resetFilters {
    display: none;
    margin-bottom: 24px;
    color: rgb(39, 49, 57);
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
  }

  .partners-resetFilters .fa {
    vertical-align: middle;
  }

  .partners-resetFilters .fa.fa-times:before {
    background: url('/steam-img/close.svg');
  }

  .partners-becomePartnerTitle {
    padding-top: 24px;

    color: rgb(39, 49, 57);
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
  }

  .partners-becomePartnerDesc {
    margin: 16px 0;

    color: rgb(39, 49, 57);
    font-size: 14px;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer .PartnersLocator__filter .partners-becomePartnerCTA {
    border: none !important;
    border-radius: 1px;
    background: rgb(0, 0, 0);
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0px;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer .PartnersLocator__filter .partners-becomePartnerCTA img {
    margin-left: 30px;
    vertical-align: middle;
  }

  .PartnersLocator__filtersContainer
    .PartnersLocator__filter
    .partners-becomePartnerCTA.PartnersLocator__becomePartnerCTA--link {
    border: none !important;
    border-radius: 1px;
    color: rgb(0, 103, 223);
    background: none;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer
    .PartnersLocator__filter
    .partners-becomePartnerCTA.PartnersLocator__becomePartnerCTA--link
    img {
    width: 32px;
    margin-left: 12px;
    vertical-align: middle;
  }

  ${'' /* Become a partner */}

  .PartnersLocator__becomePartnerTitle {
    padding-top: 24px;

    color: rgb(39, 49, 57);
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 0;
  }

  .PartnersLocator__becomePartnerDesc {
    margin: 16px 0;

    color: rgb(39, 49, 57);
    font-size: 14px;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer .PartnersLocator__filter .PartnersLocator__becomePartnerCTA {
    border: none !important;
    border-radius: 1px;
    background: rgb(0, 0, 0);
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0px;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer
    .PartnersLocator__filter
    .PartnersLocator__becomePartnerCTA
    img {
    margin-left: 30px;
    vertical-align: middle;
  }

  .PartnersLocator__filtersContainer
    .PartnersLocator__filter
    .PartnersLocator__becomePartnerCTA.PartnersLocator__becomePartnerCTA--link {
    border: none !important;
    border-radius: 1px;
    color: rgb(0, 103, 223);
    background: none;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }

  .PartnersLocator__filtersContainer
    .PartnersLocator__filter
    .PartnersLocator__becomePartnerCTA.PartnersLocator__becomePartnerCTA--link
    img {
    width: 32px;
    margin-left: 12px;
    vertical-align: middle;
  }

  /* Reset Filters */
  .PartnersLocator__resetFilters {
    display: none;
    margin-bottom: 24px;
    color: rgb(39, 49, 57);
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;

    &--active {
      display: block;
    }
  }

  .PartnersLocator__resetFilters .fa.fa-times:before {
    content: '';
    background: url('/steam-img/close.svg');
    width: 15px;
    height: 15px;
    display: inline-block;
    vertical-align: middle;
  }
`
export const PartnersLocatorTiersOuter = styled(Container)`
  background: ${({ theme }) => theme.webMktNewPalette.white};
`

export const PartnersLocatorTiers = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 66px;
  padding: 56px 0 66px 0;

  .PartnersLocator__Tier-Container p {
    margin-top: 24px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
`
